import {SubmitButton} from "components/Button";
import {FormCard} from "components/Form";
import {DashboardLayout} from "components/Layout";
import {CircleLoader} from "components/Loader";
import {useDetailDiagnosa} from "hooks/SuperAdmin/Diagnosa";
import {useHistory, useParams} from "react-router-dom";

export function MasterDiagnosaDetailPage() {
	const history = useHistory();
	const {id} = useParams();
	const {data, isLoading} = useDetailDiagnosa(id);

	if (isLoading) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar list diagnosa" title="Detail Diagnosa">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar List Diagnosa"
				title={`Detail Data Diagnosa ${data?.data?.name}`}
				onBackButtonClick={() => history.push("/master-diagnosa")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-6 col-6">
						<div class="setting-item">
							<label class="setting-label ">Nama Diagnosa</label>
							<p className="text-bold text-grey">{data?.data?.name}</p>
						</div>
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Ubah Data Ini"
						onClick={() => history.push(`/master-diagnosa/edit/${data?.data?.id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
}
